<div class="vision-values">
    <!-- section 1 contents -->
    <div class="sec-1">
        <div class="container">
            <div class="row">
                <!-- section title -->
                <div class="col-md-12 my-md-5 mb-5 sec-title">
                    <app-title-page [dataTitle]="dataTitle" [link]="'#visi-misi'"></app-title-page>
                </div>
                <!-- contents -->
                <div class="col-md-12" id="visi-misi">
                    <app-vision-mision [dataMisi]="dataSection[1]" [dataVisi]="dataSection[0]"></app-vision-mision>
                </div>
            </div>
        </div>
    </div>

    <!-- section 2 contents -->
    <div class="sec-2 mt-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-10 mx-auto">
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="fw-700 f-subtit mb-3">{{ dataSection[2]?.title }}</h4>
                            <div class="list-circle padlist no-list mb-4" [innerHTML]="dataSection[2]?.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>